import './pricingEdition.scss';
import React from 'react';
import { IPlanInfo } from '@umu/umu-types';
import { EditionItem } from './components/editionItem';

interface IPricingEditionProps {
    isRegisterUser: boolean;
    planInfo: IPlanInfo;
    siteHost: string;
    platform: 'twww' | 'mobile';
}
export const PricingEdition = (props: IPricingEditionProps) => {
    return (
        <div className="pricing-edition">
            <EditionItem {...props} />
        </div>
    );
};
